module.exports = __webpack_public_path__ + "img/img3.9513b4cd.png";